import { emptyAddress } from "common/AddressUtils";
import { FbaDeliveryDetailsState } from "freight/types/FbaDeliveryTypes";

export const fbaDeliveryDetailsInitialState: FbaDeliveryDetailsState = {
  address: { ...emptyAddress, country: "" },
  supportedFields: [],
  amazonReferenceId: "",
  amazonShipmentId: "",
};
